import React from "react";
import { CustomTable } from "../../../components";
import { Button } from "@mui/material";
import { makeStyles } from "@mui/styles";

import { vendorPodTableHeading } from "../../../assets/lib/vendorPod";
import { collection, getDocs } from "firebase/firestore";
import * as XLSX from "xlsx";
import { db } from "../../../config/firebase";
import { COLLECTION } from "../../../data/constant";

const customStyle = makeStyles({
  root: {
    padding: "60px 40px",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "30px",
  },
  topActions: {
    display: "flex",
    justifyContent: "flex-end",
    marginBottom: "10px",
  },
  '@media (max-width: 390px)': {
    root: {
      padding: "10px 5px",
      width: "80%",
      display: "flex",
      flexDirection: "column",
      gap: "30px",
    },
  },
});

const Layout = (props) => {
  const {
    vendorPodData,
    isTableLoading,
    currentPage,
    totalLength,
    handlePageChange,
    handlePageSize,
    handleSearchQuery,
    handleTableSorting,
  } = props;

  const classes = customStyle();

  // 🔽 Handler to download snack preferences as Excel
  const handleDownloadSnackPreferences = async () => {
    try {
      const snap = await getDocs(collection(db, COLLECTION.SNACKPREFERENCES));
      const rows = [];

      snap.forEach((doc) => {
        const data = doc.data();
        rows.push({
          PhoneNumber: data.phoneNumber,
          SnackPreferences: data.snacks,
          Timestamp: data.timestamp?.toDate().toLocaleString() || "N/A",
        });
      });

      const worksheet = XLSX.utils.json_to_sheet(rows);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "SnackPreferences");

      XLSX.writeFile(workbook, "SnackPreferences.xlsx");
    } catch (error) {
      console.error("Error downloading snack preferences:", error);
    }
  };

  return (
    <div className={classes.root}>
      <div className={classes.topActions}>
        <Button
          variant="contained"
          style={{backgroundColor:"black",color:"white"}}
          onClick={handleDownloadSnackPreferences}
        >
          Download Snack Preferences
        </Button>
      </div>

      <CustomTable
        columns={vendorPodTableHeading}
        data={vendorPodData}
        isLoading={isTableLoading}
        currentPage={currentPage}
        totalLength={totalLength}
        handlePageChange={handlePageChange}
        handlePageSize={handlePageSize}
        handleTableSorting={handleTableSorting}
      />
    </div>
  );
};

export default Layout;
